/*
 * RemovalCandidatesTree.
 */

export class RemovalCandidatesTree {
  private subtrees = new Map<string, RemovalCandidatesTree>();
  private hasItem = false;

  add(path: ReadonlyArray<string>) {
    if (path.length === 0) {
      this.hasItem = true;
      return;
    }

    const [key, ...remainingPath] = path;
    const subtree = this.getOrMakeSubtree(key);
    subtree.add(remainingPath);
  }

  delete(path: ReadonlyArray<string>) {
    if (path.length === 0) {
      this.hasItem = false;
      return;
    }

    const [key, ...remainingPath] = path;
    const subtree = this.subtrees.get(key);
    if (!subtree) {
      return;
    }

    subtree.delete(remainingPath);
    if (subtree.size === 0) {
      this.subtrees.delete(key);
    }
  }

  /** Get all the items relative to the path. */
  get(path: ReadonlyArray<string>): ReadonlyArray<ReadonlyArray<string>> {
    if (path.length === 0) {
      return this.list();
    }

    const [key, ...remainingPath] = path;
    const subtree = this.subtrees.get(key);
    if (!subtree) {
      return [];
    }

    return subtree.get(remainingPath);
  }

  /** Get's all the items in this tree. */
  list(): ReadonlyArray<ReadonlyArray<string>> {
    const paths = [];
    if (this.hasItem) {
      paths.push([]);
    }

    this.subtrees.forEach((subtree, key) => {
      subtree.list().forEach((path) => {
        paths.push([key, ...path]);
      });
    });

    return paths;
  }

  get size() {
    if (!this.hasItem) {
      return this.subtrees.size;
    }

    return this.subtrees.size + 1;
  }

  private getOrMakeSubtree(key: string) {
    const subtree = this.subtrees.get(key);
    if (subtree) {
      return subtree;
    }

    const newSubtree = new RemovalCandidatesTree();
    this.subtrees.set(key, newSubtree);
    return newSubtree;
  }
}
